import axios from "axios";
import paramsBuilder from "./params-builder";
import store from "@/store";
// import router from "@/router";

const getAxiosInstance = () => {
  const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
      "Content-type": "application/json",
    },
  });

  // Add interceptors for request
  axiosInstance.interceptors.request.use(
    function (config) {
      // add queryparams to headers reqeust
      // if (store.state.queryParams)
      //   Object.keys(store.state.queryParams).forEach((key) => {
      //     config.headers[key] = store.state.queryParams[key];
      //   });
      // if (!navigator.onLine) {
      //     console.log("عدم اتصال به اینترنت!");
      //     return;
      //   }

      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  // Add interceptors for response
  axiosInstance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response) {
        const errorMessage =
          error.response.data?.message || error.response.data?.error;

        switch (error.response.status) {
          case 401:
          case 403:
            store.commit("showSnackbar", errorMessage ?? "دسترسی غیر مجاز");
            // router.push({ name: "Forbidden" });
            break;

          case 500:
            store.commit("showSnackbar", "خطای داخلی سرور");
            break;

          default:
            store.commit("showSnackbar", {
              message: errorMessage ?? "خطا در دریافت اطلاعات",
            });
        }
      } else if (error.request) {
        // The request was made but no response was received
        store.commit(
          "showSnackbar",
          "خطایی رخ داده است. ارتباط اینترنت خود را بررسی کنید."
        );
      } else {
        // Something happened in setting up the request that triggered an Error
        store.commit(
          "showSnackbar",
          "خطایی در پردازش اطلاعات رخ داده است. لطفا بعدا امتحان کنید."
        );
      }

      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

const getCancelToken = (cancelTokenSource) =>
  cancelTokenSource ? cancelTokenSource.token : null;
// clone instance and add new config to instance
const getInstance = (newAxiosConfig) => {
  let instance = getAxiosInstance();
  Object.keys(newAxiosConfig).forEach(
    (property) => (instance.defaults[property] = newAxiosConfig[property])
  );

  return instance;
};

const http = {
  get: ({ url, cancelTokenSource = null, httpOptions = {} }) => {
    let instance = getInstance(httpOptions);

    return instance.get(url, {
      cancelToken: getCancelToken(cancelTokenSource),
    });
  },

  getByParams: ({
    url,
    params,
    cancelTokenSource = null,
    httpOptions = {},
  }) => {
    let instance = getInstance(httpOptions);
    // instance.defaults.headers['Content-type'] = 'application/x-www-form-urlencoded';

    let readyParams = {};
    if (params) {
      // to remove empty params
      const paramsWithoutEmpty = {};
      Object.keys(params).forEach((key) => {
        if (
          params[key] !== null &&
          params[key] !== "" &&
          params[key] !== undefined
        )
          paramsWithoutEmpty[key] = params[key];
      });

      // readyParams = decodeURIComponent(paramsBuilder(paramsWithoutEmpty)).replace(/\[\]/g, "");
      readyParams = decodeURIComponent(paramsBuilder(paramsWithoutEmpty));
    }
    // Note: correct querystring => ?id=1&myArray[]=1&myArray[]=2
    // but aspcore can't handle this , then querystring change to above line(remove [])

    return instance.get(url + "?" + readyParams, {
      cancelToken: getCancelToken(cancelTokenSource),
    });
    // return instance.get(url, { params: params, cancelToken: getCancelToken(cancelTokenSource) }); //  it makes params too.they are the same
  },

  postByParams: ({
    url,
    params = null,
    cancelTokenSource = null,
    httpOptions = {},
  }) => {
    let instance = getInstance(httpOptions);

    let readyParams = {};
    if (params) readyParams = paramsBuilder(params);

    return instance.post(url, readyParams, {
      cancelToken: getCancelToken(cancelTokenSource),
    });
  },

  post: ({ url, payload, cancelTokenSource = null, httpOptions = {} }) => {
    let instance = getInstance(httpOptions);

    return instance.post(url, payload, {
      cancelToken: getCancelToken(cancelTokenSource),
    });
  },

  postByFormData: ({
    url,
    formData,
    cancelTokenSource = null,
    httpOptions = {},
  }) => {
    let instance = getInstance(httpOptions);

    return instance.post(url, formData, {
      headers: { "Content-type": "multipart/form-data" },
      cancelToken: getCancelToken(cancelTokenSource),
    });
  },

  put: ({ url, payload, cancelTokenSource = null, httpOptions = {} }) => {
    let instance = getInstance(httpOptions);

    return instance.put(url, payload, {
      cancelToken: getCancelToken(cancelTokenSource),
    });
  },

  delete: ({ url, cancelTokenSource = null, httpOptions = {} }) => {
    let instance = getInstance(httpOptions);

    return instance.delete(url, {
      cancelToken: getCancelToken(cancelTokenSource),
    });
  },

  patch: ({ url, payload, cancelTokenSource = null, httpOptions = {} }) => {
    let instance = getInstance(httpOptions);

    return instance.patch(url, payload, {
      cancelToken: getCancelToken(cancelTokenSource),
    });
  },
};

export { http };
